export enum ProjectPositionStatus {
  OPEN_FOR_APPLICANTS = 'OPEN_FOR_APPLICANTS',
  CLOSED_FOR_APPLICANTS = 'CLOSED_FOR_APPLICANTS',
  FILLED = 'FILLED',
  REMOVED = 'REMOVED'
}

export const PROJECT_POSITION_STATUS_MAP = {
  [ProjectPositionStatus.OPEN_FOR_APPLICANTS]: 'Open for Applicants',
  [ProjectPositionStatus.CLOSED_FOR_APPLICANTS]: 'Closed for Applicants',
  [ProjectPositionStatus.FILLED]: 'Filled',
  [ProjectPositionStatus.REMOVED]: 'Removed',
};